module.exports = __webpack_public_path__ + "static/media/history-points.12b979f1.svg";